import { render, staticRenderFns } from "./OrderDataDetail.vue?vue&type=template&id=026e3dec&scoped=true"
import script from "./OrderDataDetail.vue?vue&type=script&lang=js"
export * from "./OrderDataDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderDataDetail.vue?vue&type=style&index=0&id=026e3dec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026e3dec",
  null
  
)

export default component.exports